import { render, staticRenderFns } from "./InformacionCambiosEdicionPtiV5.vue?vue&type=template&id=39039066&scoped=true"
import script from "./InformacionCambiosEdicionPtiV5.vue?vue&type=script&lang=js"
export * from "./InformacionCambiosEdicionPtiV5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39039066",
  null
  
)

export default component.exports